
import { FormElementController, FormPageValidator, FormElementValidator, StringValidators } from './../../../scripts/formcontrols'
import { PatientDto } from '../../../dto/Fmd/Models';
import FmdDal from '../../../scripts/FmdDal';
import UiSession from '../../../Tracking/LogManager';

export class NewPatientFormController extends FormPageValidator {

    private dal: FmdDal;
    //private unitId: string;
    private EditingPatient: PatientDto;

    public Title: FormElementController<string>;
    public FirstName: FormElementController<string>;
    public MiddleName: FormElementController<string>;
    public LastName: FormElementController<string>;


    public NhsId:  FormElementController<string>;
    public Dob: FormElementController<Date>;
    public Sex: FormElementController<string>;
    //public Mobile:  FormElementController<string>;
    //public Email: FormElementController<string>;

    public addressLine: FormElementController<string>;
    //public Line2: FormElementController<string>;
    //public Line3: FormElementController<string>;
    //public Town: FormElementController<string>;
    public PostCode: FormElementController<string>;

    public Suggestions: Array<PatientDto> = [];

    constructor(unitId: string, uiSession: UiSession) {
        super();

        this.dal = new FmdDal(unitId, uiSession);
        //this.unitId = unitId;

        var titleValidator = new FormElementValidator<string>(true);
        var firstNameValidator = new FormElementValidator<string>(true);
        var lastNameValidator = new FormElementValidator<string>(true);
        var dobValidator = new FormElementValidator<Date>(true);
        var sexValidator = new FormElementValidator<string>(true);

        this.addValidators(titleValidator, firstNameValidator, lastNameValidator, dobValidator, sexValidator);


        var capitalize = (v: string): string => {
            if (v) {
                return v.charAt(0).toUpperCase() + v.slice(1);
            }
            return "";
        }

        this.Title = new FormElementController<string>("Title", "", titleValidator, capitalize);
        this.FirstName = new FormElementController<string>("First Name", "", firstNameValidator, capitalize);
        this.MiddleName = new FormElementController<string>("Middle Name", "", undefined, capitalize);
        this.LastName = new FormElementController<string>("Last Name", "", lastNameValidator, capitalize);

        this.Dob = new FormElementController<Date>("Dob", new Date(1950, 1, 1), dobValidator);

        this.Sex = new FormElementController<string>("Sex", "Male", sexValidator);

        this.NhsId = new FormElementController<string>("NhsId", "");
        //this.Mobile = new FormElementController<string>("Mobile", "" );
        //this.Email = new FormElementController<string>("Email", "");

        this.addressLine = new FormElementController<string>("Address", "");
        //this.Line2  = new FormElementController<string>("Line2", "");
        //this.Line3  = new FormElementController<string>("Line3", "");
        //this.Town   = new FormElementController<string>("Town", "", mandatoryValidation);
        this.PostCode = new FormElementController<string>("Post code", "");

        var that = this;
        //this.FirstName.OnChange(function (v) { that.UpdateSuggestions() });
        //this.LastName.OnChange(function (v) { that.UpdateSuggestions() });
        //this.Dob.OnChange(v => this.UpdateSuggestions());
        //this.PostCode.OnChange(v => this.UpdateSuggestions());


    }
    public GetDto(): PatientDto {
        var dto = new PatientDto();
        if (this.EditingPatient) {
            dto.id = this.EditingPatient.id;
            dto.addressId = this.EditingPatient.addressId;
        }
        dto.title = this.Title.value;
        dto.firstName = this.FirstName.value;
        dto.middleName = this.MiddleName.value;
        dto.lastName = this.LastName.value;
        dto.dob = this.Dob.value;
        dto.addressLine = this.addressLine.value;
        dto.postCode = this.PostCode.value;

        dto.nhsNumber = this.NhsId.value;
        dto.sex = this.Sex.value;
        return dto;
    }


    public Reset(): void {

        this.Title.value = ""
        this.FirstName.value = ""
        this.MiddleName.value = ""
        this.LastName.value = ""

        this.NhsId.value = ""
        this.Dob.value = new Date()
        this.Sex.value = ""
        //this.Mobile = 
        //this.Email = n

        this.addressLine.value = ""
        //this.Line2  = 
        //this.Line3  = 
        //this.Town   = 
        this.PostCode.value = ""


    }

    public Initialize(p: PatientDto): void {
        this.EditingPatient = p;
        console.log(p)
        this.Title.value = p.title
        this.FirstName.value = p.firstName
        this.MiddleName.value = p.middleName
        this.LastName.value = p.lastName

        this.NhsId.value = p.nhsNumber
        this.Dob.value = p.dob
        this.Sex.value = p.sex

        this.addressLine.value = p.addressLine
        this.PostCode.value = p.postCode

        this.validate()
    }
    private UpdateSuggestions(): void{
        var that = this;

        this.dal.SearchPatients(this.FirstName.value + " " + this.LastName.value + " " +  this.PostCode.value)
        //fmdDal.SearchPatientByFields(this.FirstName.value, this.LastName.value, this.Dob.value, this.PostCode.value)
            .then(data => {
                var result = new Array<PatientDto>();
                data.map(i => result.push(i));
                that.Suggestions = result;
                console.log(that.Suggestions);
            });
    }

}


// WEBPACK FOOTER //
// ./ClientApp/components/appcontrols/NewPatientForm/NewPatientFormController.ts